import * as React from 'react';
import Block from "@layout/Block";
import Font from "@layout/Font";
import { PieceUnorderedList } from '@store/index';

interface Props {
    piece: PieceUnorderedList;
}

const UnorderedListPiece = ({ piece }: Props) => (
    <Block indent="20">
        <Block indent="20">
            <div className="grid">
                <div className="grid-6 line-bottom">
                    <Font font="primary">
                        { piece.title }
                    </Font>
                </div>
            </div>
        </Block>

        <Font font="secondary" size={20} lineHeight={1.4}>
            <ul className="list">
                {
                    piece.items.map((item, index) => (
                        <li key={`unordered-list-piece-${index}`}>{ item }</li>
                    ))
                }
            </ul>
        </Font>
    </Block>
);

export default UnorderedListPiece;


// WEBPACK FOOTER //
// ./src/components/layout/pieces/UnorderedList/index.tsx